<template>
  <div>
    <LRLayout class="lr_layout_out">
      <LeftPanel style="overflow:auto" class="layout_left_panel">
        <ArticleCateTree />
      </LeftPanel>
      <RightPanel class="layout_right_panel">
        <ArticleList :type="type" />
      </RightPanel>
    </LRLayout>
    <!-- <ArticleList v-else :type="type" /> -->
  </div>
</template>

<script>
import ArticleCateTree from './components/ArticleCateTree'
import ArticleList from './components/ArticleList'
export default {
    components: {
        ArticleCateTree, ArticleList
    },
    props: {

    },
    data() {
        return {
            type: '',
            isHeadlins: ''
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        console.log('route==========', this.$route)
        const params = this.$route.meta.params.split('&')
        params.forEach(val => {
            this[val.split('=')[0]] = Number(val.split('=')[1])
        })
        if (this.$route.query.type) {
            this.type = this.$route.query.type
        }
        console.log('this.type', this.type)
    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.lr_layout_out{
  display: flex;
  .layout_left_panel{
    float: none;
    min-height: 200px;
    height: auto;
    width: 200px;
  }
  .layout_right_panel{
    flex: 1;
    float: none;
    margin-left:10px;
    // width:100%;
  }
}
</style>
